import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  z-index: 99;
`;

export const ContentWrapper = styled.div`
  position: absolute;
  left: -12px;
  bottom: calc(100% + 6px);
  width: max-content;
  max-width: 192px;
  background: ${({ theme }) => theme.colors.neutral[800]};
  border-radius: 4px;
  padding: 8px 12px 12px 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 14px;
    border-width: 5px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.neutral[800]} transparent
      transparent transparent;
  }
`;
